export const COL_SPAN_PREFIX = 'span-';
export const COL_START_PREFIX = 'start-';
export const COL_END_PREFIX = 'end-';
// column prefixes for classes common to all resolutions/ breakpoints
export const COL_SPAN_PREFIX_CMN = 'naos-gcol--span-';
export const COL_START_PREFIX_CMN = 'naos-gcol--start-';
export const COL_END_PREFIX_CMN = 'naos-gcol--end-';
export const COL_BREAKPOINT_PREFIX = 'naos-gcol--';
export const BREAKPOINTS = {
  S: 'S',
  // small
  M: 'M',
  // medium
  L: 'L' // large
};
export const COL_DEF_PARAMS = {
  SPAN: 'span',
  START: 'start',
  END: 'end'
};